



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NavType from "./Type/NavType";
//utils
import Utils from "../utils/utils";
@Component
export default class Header extends Utils {
  private currentNav: any = 0;
  private navLink: NavType[] = [
    { name: "首页", router: "/home" },
    { name: "免费下载", router: "/download" }
  ];
  public created() {
    if (this.getNavIndex() !== null) {
      this.currentNav = parseInt(this.getNavIndex() + "");
    }
  }
  private changeNav(item: NavType, index: number) {
    this.currentNav = index;
    this.$router.push(item.router);
  }
  public get changeCurrent() {
    return this.currentIndex;
  }
  @Watch("changeCurrent")
  public navColorChange() {
    this.currentNav = this.changeCurrent;
  }
}
